import * as React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import styled from '@emotion/styled';

const MenuBtn = styled(Button)`
    font-size: 22px;
    color: #fff;
    padding-left: 20px;
`
const MenuEx = styled(Menu)`
  
  
  .MuiList-root{ background-color: #000000;padding: 5px 20px;}
`

const MenuItemEx = styled(MenuItem)`
    color: #FFFFFF;
    text-align: center;
    justify-content: center;
    padding: 12px 15px;
    border-bottom: 1px solid gray;
    &:last-child{
      border-bottom: 0px solid gray;
    }

    a{
      font-size: 22px;
      color: #fff;
      text-decoration: none;
    }
`


export default function MenuDropdown() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <MenuBtn
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        Menu
      </MenuBtn>
      <MenuEx
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItemEx onClick={handleClose}><a href="/">Home</a></MenuItemEx>
        <MenuItemEx onClick={handleClose}><a href="/earn">Earn</a></MenuItemEx>
        <MenuItemEx onClick={handleClose}><a href="/tokenomics">Tokenomics</a></MenuItemEx>
        <MenuItemEx onClick={handleClose}><a href="/vegan-options">Vegan Options</a></MenuItemEx>
      </MenuEx>
    </div>
  );
}